import React from "react";
import clsx from "clsx";
import RoomBuilderErrors from "../RoomBuilderErrors";

class RoomBuilderGeneral extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate() {
    if (typeof initTypeahead == "function" && this.refs.root) {
      window.initTypeahead($(this.refs.root).find("[data-model][data-column]"));
    }
  }

  render() {
    var tabClasses = clsx({
      active: this.props.active_tab == "general",
      "tab-pane": true,
    });
    return (
      <div className={`${tabClasses} root`} id="general">
        <div className="rooms single">
          {this.renderErrors()}
          <div className="row">
            <div className="col-md-7">{this.renderGeneralForm()}</div>
          </div>
        </div>
      </div>
    );
  }

  renderGeneralForm() {
    return (
      <div>
        <div className="row form-group" style={{ marginBottom: 0 }}>
          <div className="col-sm-6">
            <label>{`${I18n.t("room_identifier")}*`}</label>{" "}
            <span
              className="ss-help help"
              title={I18n.t("identifier_helper_text")}
            ></span>
            <input
              type="text"
              name="identifier"
              maxLength="25"
              className={this.renderFieldClasses("identifier")}
              defaultValue={this.props.room.identifier}
              data-model="Room"
              data-column="identifier"
              onChange={this.props.onIdentifierChange}
            />
            {this.renderFieldErrors("identifier")}
          </div>
          <div className="col-sm-4">
            <label>{`${I18n.t("floor")}`}</label>
            <input
              type="number"
              name="floor"
              // maxLength="25"
              className={this.renderFieldClasses("floor")}
              defaultValue={this.props.room.floor}
              data-model="Room"
              data-column="identifier"
              onChange={this.props.onIdentifierChange}
            />
          </div>
        </div>
      </div>
    );
  }

  renderErrors() {
    if (this.props.errors) {
      var errors = RoomBuilderErrors.general(this.props.errors);
      if (errors && errors.length) {
        var idx = 0;
        var errors = errors.map((error) => {
          idx = idx + 1;
          return <li key={error + idx}>{error}</li>;
        });
        return (
          <div className="alert alert-danger">
            <ul>{errors}</ul>
          </div>
        );
      }
    }
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0;

      var errors = this.props.errors[field].map((error) => {
        if (field === "identifier") field = I18n.t("room_identifier") ;
        idx = idx + 1;
        return (
          <li key={idx}>
            <b>{field}</b> {error}
          </li>
        );
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFieldClasses(field) {
    var classname = "form-control";
    if (
      this.props.errors &&
      Object.keys(this.props.errors).length &&
      this.props.errors[field]
    ) {
      classname = classname + " has-errors";
    }
    return classname;
  }
}

export default RoomBuilderGeneral;
